import React from 'react';
import Description from '../Description/index'
import './index.css'
import WeatherImg from '../WeatherImg/index'

const TinyCard = (props) => {
    const {desc,hoy,tempMinMax}=props
    return ( 
            <div className="TinyCard">
        <Description desc={desc}/>
        <WeatherImg link={hoy} />
        <Description desc={tempMinMax}/>

        </div>
     );
}
 
export default TinyCard;